module.exports = __webpack_public_path__ + "img/资源 323.52ba996f.png";